import axios from '@/utils/request'

export default {
  getProductAdBar: params => axios({ url: '/api/product/open/ad/ad', method: 'get', params }), // 获取广告栏
  setProductAdBar: data => axios({ url: '/api/product/manage/ad/ad', method: 'post', data }), // 编辑广告栏
}